class ViewSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleViewToggle = this.handleViewToggle.bind(this)
    this.handleViewTrigger = this.handleViewTrigger.bind(this)

    this.listeners.add(this.els.toggle.element, 'click', this.handleViewToggle)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleViewTrigger)
    })
  }

  async handleViewToggle () {
    const currentView = this.dataset.mobileView

    const newView = currentView === 'Standard' ? 'Large' : 'Standard'

    this.updateView('mobile', currentView, newView)
  }

  handleViewTrigger (event) {
    const currentView = this.dataset.desktopView

    const newView = event.target.dataset.view

    if (newView === currentView) return

    this.updateView('desktop', currentView, newView)

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl.dataset.view === newView) {
        triggerEl.setAttribute('aria-current', 'page')
      } else {
        triggerEl.removeAttribute('aria-current')
      }
    })
  }

  async updateView (viewport, currentView, newView) {
    const listClass = `clc-ProductGrid`

    if (viewport === 'desktop') {
      await window.BAO.Cart.updateCartAttributes({
        desktop_view: newView,
      })
    } else {
      await window.BAO.Cart.updateCartAttributes({
        mobile_view: newView,
      })
    }

    this.setAttribute(`data-${viewport}-view`, newView)

    this.externalEls.grid.element.classList.remove(
      `${listClass}-${viewport}${currentView}`,
    )
    this.externalEls.grid.element.classList.add(
      `${listClass}-${viewport}${newView}`,
    )
  }
}

if (!customElements.get('view-switch')) {
  customElements.define('view-switch', ViewSwitch)
}
